import { render, staticRenderFns } from "./ParameterDangerZone.vue?vue&type=template&id=9b818408&scoped=true&"
import script from "./ParameterDangerZone.vue?vue&type=script&lang=js&"
export * from "./ParameterDangerZone.vue?vue&type=script&lang=js&"
import style0 from "./ParameterDangerZone.vue?vue&type=style&index=0&id=9b818408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b818408",
  null
  
)

export default component.exports